export default function useGetCorrectedCountryCode(countryCode: string): string {
  if (countryCode === 'default' || countryCode === 'uk') {
    return 'us'
  }
  return countryCode
}
